/**
 * BMAT Layout Module
 */
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { BMContentComponent } from './bm-content/bm-content.component';
import { BMHeaderComponent } from './bm-header/bm-header.component';
import { BMSidenavContainerComponent } from './bm-sidenav/bm-sidenav.component';
import { BMCollapsableDirective } from './directives/collapsable/collapsable.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    BMCollapsableDirective,
    BMContentComponent,
    BMHeaderComponent,
    BMSidenavContainerComponent,
  ],
  exports: [
    BMCollapsableDirective,
    BMContentComponent,
    BMHeaderComponent,
    BMSidenavContainerComponent,
  ],
  providers: [],
})
export class BMATLayoutModule {
  // tslint:disable-next-line:function-name
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: BMATLayoutModule,
      providers: [],
    };
  }
}
